export enum PaymentType {
  Payment = 'Payment',
  Refund = 'Refund',
}